import React from "react";
import { TEXTS, formatText } from "../../constants";
import logoSvg from "../../assets/light-logo.svg";
import {
  SignPageWrapper,
  PageContent,
  DecorativeShape,
  SuccessContainer,
  SuccessContent,
  SuccessAnimation,
  SuccessCheckmark,
  SuccessDetails,
  HashCode,
  EmailNotice,
  Logo,
} from "./SignPage.styles";
import { Card } from "../../styles/SharedStyles";

function SuccessScreen({ signedData, clientName }) {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const date = d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const time = d.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return `${date} ${time}`;
  };

  return (
    <SignPageWrapper>
      <DecorativeShape className="shape1" />
      <DecorativeShape className="shape2" />
      <DecorativeShape className="shape3" />
      <DecorativeShape className="shape4" />
      <PageContent>
        <SuccessContainer>
          <Card style={{ padding: "40px 32px" }}>
            <SuccessContent>
              {/* DevCraft Logo */}
              <Logo
                src={logoSvg}
                alt="DevCraft"
                style={{ marginBottom: "20px" }}
              />

              {/* Success Animation */}
              <SuccessAnimation>
                <SuccessCheckmark>✓</SuccessCheckmark>
              </SuccessAnimation>

              <h1
                style={{
                  color: "#1E8E3E",
                  marginBottom: "8px",
                  fontSize: "1.375rem",
                  fontWeight: 500,
                }}
              >
                {TEXTS.SUCCESS.TITLE}
              </h1>

              <p style={{ color: "#5F6368", fontSize: "0.9375rem", margin: 0 }}>
                {formatText(TEXTS.SUCCESS.THANK_YOU, { name: clientName })}
              </p>

              <SuccessDetails>
                <p>
                  <strong>{TEXTS.SUCCESS.DETAILS.SIGNED_AT}</strong>{" "}
                  {formatDate(signedData?.signedAt)}
                </p>
                <p>
                  <strong>{TEXTS.SUCCESS.DETAILS.CONTRACT_ID}</strong>{" "}
                  {signedData?.contractId}
                </p>
                {signedData?.finalHash && (
                  <p style={{ fontSize: "0.8125rem" }}>
                    <strong>{TEXTS.SUCCESS.DETAILS.VERIFICATION_HASH}</strong>
                    <HashCode>{signedData.finalHash}</HashCode>
                  </p>
                )}
              </SuccessDetails>

              <EmailNotice>
                <p>{TEXTS.SUCCESS.EMAIL_NOTICE}</p>
              </EmailNotice>

              <p
                style={{
                  marginTop: "24px",
                  color: "#80868B",
                  fontSize: "0.875rem",
                  margin: "24px 0 0 0",
                }}
              >
                {TEXTS.SUCCESS.CAN_CLOSE}
              </p>
            </SuccessContent>
          </Card>
        </SuccessContainer>
      </PageContent>
    </SignPageWrapper>
  );
}

export default SuccessScreen;
